import React, { useRef, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from "@material-ui/core/Popover";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import SendIcon from "@material-ui/icons/Send";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { customerWalletVisible, formatWallet } from "./helpers";
import { PointsSendTrigger } from "./CustomerServiceDialog";
import { stopRow, tNegocio } from "./shared";

/** Compact wallet access for customer rows on desktop and mobile. */
export default function WalletBalanceAction({ customer }) {
  const [anchor, setAnchor] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const request = useRef(0);
  const close = () => { request.current += 1; setAnchor(null); setLoading(false); };
  const open = async (event) => {
    const id = ++request.current;
    setAnchor(event.currentTarget);
    setDetail(null);
    setLoading(true);
    try {
      const { data } = await api.get(`/negocio/customers/${customer.contactId}`);
      if (request.current === id) setDetail({ ...customer, ...data });
    } catch (error) {
      if (request.current === id) toastError(error);
    } finally {
      if (request.current === id) setLoading(false);
    }
  };
  if (!customer?.contactId || !customerWalletVisible(customer)) return null;
  return <span onClick={(event) => event.stopPropagation()} onKeyDown={(event) => event.stopPropagation()}>
    <Tooltip title={tNegocio("pages.customers.walletHistory")}>
      <IconButton size="small" color="primary" aria-label={tNegocio("pages.customers.walletHistory")} onClick={stopRow(open)}>
        <AccountBalanceWalletIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Popover open={!!anchor} anchorEl={anchor} onClose={close} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
      <div style={{ padding: 12, maxWidth: 260 }}>
        <div style={{ fontWeight: 600, overflowWrap: "anywhere" }}>{customer.name}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 8 }}>
          <strong aria-live="polite">{loading ? tNegocio("loading") : detail ? formatWallet(detail.walletBalance, detail.walletCurrency) : "—"}</strong>
          <PointsSendTrigger customer={detail} disabled={loading || !detail}>
            <IconButton size="small" color="primary" aria-label={tNegocio("pages.customers.sendWallet")}><SendIcon fontSize="small" /></IconButton>
          </PointsSendTrigger>
        </div>
      </div>
    </Popover>
  </span>;
}
